export const getFavicons = (state) => state.favicons
